import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

const SalesDetailBarChart = ({ salesData, year }) => {
    const actualProject = salesData?.actual?.project || 0;
    const actualMaintenance = salesData?.actual?.maintenance || 0;
    const actualSalesTotal = actualProject + actualMaintenance; 

    const forecastProject = salesData?.forecast?.project || 0;
    const forecastMaintenance = salesData?.forecast?.maintenance || 0;
    const forecastSalesTotal = forecastProject + forecastMaintenance; 

    const actProjRate = actualSalesTotal > 0 ? Number(((actualProject / actualSalesTotal) * 100).toFixed(1)) : 0;
    const actMaintRate = actualSalesTotal > 0 ? Number(((actualMaintenance / actualSalesTotal) * 100).toFixed(1)) : 0;

    const foreProjRate = forecastSalesTotal > 0 ? Number(((forecastProject / forecastSalesTotal) * 100).toFixed(1)) : 0;
    const foreMaintRate = forecastSalesTotal > 0 ? Number(((forecastMaintenance / forecastSalesTotal) * 100).toFixed(1)) : 0;

    const counts = { actProj: 3, actMaint: 1, foreProj: 2, foreMaint: 2 };
    const actTotalCount = counts.actProj + counts.actMaint;
    const foreTotalCount = counts.foreProj + counts.foreMaint;

    const rowsData = [
        {
            title: '수주 유형',
            projAmt: actualProject,
            projRate: actProjRate,
            projCount: counts.actProj,
            maintAmt: actualMaintenance,
            maintRate: actMaintRate,
            maintCount: counts.actMaint,
            totalAmt: actualSalesTotal,
            totalCount: actTotalCount,
            clickKey: '수주 내역 세부',
            chartData: [{ name: '수주 내역 세부', 프로젝트율: actProjRate, 유지보수율: actMaintRate }]
        },
        {
            title: '포캐스팅 유형',
            projAmt: forecastProject,
            projRate: foreProjRate,
            projCount: counts.foreProj,
            maintAmt: forecastMaintenance,
            maintRate: foreMaintRate,
            maintCount: counts.foreMaint,
            totalAmt: forecastSalesTotal,
            totalCount: foreTotalCount,
            clickKey: '포캐스팅 세부',
            chartData: [{ name: '포캐스팅 세부', 프로젝트율: foreProjRate, 유지보수율: foreMaintRate }]
        }
    ];

    const formatXAxis = (value) => `${value}%`;

    const handleBarClick = (category, type) => {
        if (category === 'SPACER') return;
        const titleName = category.includes('수주') ? '현재 수주 실적' : '포캐스팅 예상';
        alert(`[${titleName}] ${type} 관련 계약 현황 및 상세 프로젝트 목록 팝업을 호출합니다.`);
    };

    const textLinkStyle = (color) => ({
        color: color,
        fontWeight: '700',
        cursor: 'pointer',
        borderBottom: '1px dashed transparent',
        transition: 'all 0.15s ease',
        padding: '2px 4px',
        borderRadius: '4px',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', whiteSpace: 'nowrap',
        boxSizing: 'border-box'
    });

    const handleMouseOver = (e, hoverBg) => {
        e.currentTarget.style.backgroundColor = hoverBg;
        e.currentTarget.style.borderBottom = '1px dashed currentColor';
    };
    const handleMouseOut = (e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.borderBottom = '1px dashed transparent';
    };

    const SearchIcon = () => (
        <svg width="11" height="11" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '4px', opacity: 0.6, flexShrink: 0 }}>
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    );
    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', background: '#ffffff', border: '1px solid #E2E8F0', borderRadius: '12px', overflow: 'hidden', boxSizing: 'border-box' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', backgroundColor: '#F1F5F9', borderBottom: '1px solid #E2E8F0', boxSizing: 'border-box' }}>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#334155', letterSpacing: '-0.3px' }}>
                    {year}년 수주 및 포캐스팅 유형<span style={{ fontSize: '11px', fontWeight: '600', color: '#2563EB', marginLeft: '6px' }}>(금액 또는 막대를 클릭하면 상세 내역이 열립니다)</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '700' }}>
                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '2px', backgroundColor: '#1E3A8A', marginRight: '4px' }}></span>
                        <span style={{ color: '#475569' }}>프로젝트</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '700' }}>
                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '2px', backgroundColor: '#0EA5E9', marginRight: '4px' }}></span>
                        <span style={{ color: '#475569' }}>유지보수</span>
                    </div>
                </div>
            </div>
            
            <div style={{ flex: '1', width: '100%', padding: '20px 20px 12px 20px', display: 'flex', flexDirection: 'column', gap: '28px', boxSizing: 'border-box', position: 'relative' }}>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '28px', width: '100%', zIndex: 2, position: 'relative' }}>
                    {rowsData.map((row) => (
                        <div key={row.title} style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '20px' }}>
                                <div style={{ fontSize: '12px', fontWeight: '700', color: '#0F172A', width: '120px', flexShrink: 0 }}>{row.title}</div>
                                <div style={{ display: 'flex', gap: '5px', fontSize: '12px', fontWeight: '600', color: '#475569', flex: 1, justifyContent: 'flex-end' }}>
                                    
                                    <div style={{ ...textLinkStyle('#1E3A8A'), width: '255px', display: 'flex', alignItems: 'center' }} onMouseOver={(e) => handleMouseOver(e, '#EEF2F6')} onMouseOut={handleMouseOut} onClick={() => handleBarClick(row.clickKey, '프로젝트')}>
                                        <span style={{ width: '54px', flexShrink: 0 }}>프로젝트:</span>
                                        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: '2px' }}>
                                            <span style={{ color: '#1E3A8A', fontWeight: '700' }}>{row.projAmt.toLocaleString()}</span>
                                        </div>
                                        <span style={{ width: '14px', flexShrink: 0 }}>원</span>
                                        <span style={{ color: '#1E3A8A', fontWeight: '700', fontSize: '12px', width: '44px', textAlign: 'right', flexShrink: 0 }}>({row.projRate}%)</span>
                                        <span style={{ width: '25px', textAlign: 'right', flexShrink: 0, marginLeft: '4px' }}>[{row.projCount}건]</span>
                                        <SearchIcon />
                                    </div>
                                    
                                    <div style={{ ...textLinkStyle('#0EA5E9'), width: '255px', display: 'flex', alignItems: 'center' }} onMouseOver={(e) => handleMouseOver(e, '#F0F9FF')} onMouseOut={handleMouseOut} onClick={() => handleBarClick(row.clickKey, '유지보수')}>
                                        <span style={{ width: '54px', flexShrink: 0 }}>유지보수:</span>
                                        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: '2px' }}>
                                            <span style={{ color: '#0EA5E9', fontWeight: '700' }}>{row.maintAmt.toLocaleString()}</span>
                                        </div>
                                        <span style={{ width: '14px', flexShrink: 0 }}>원</span>
                                        <span style={{ color: '#0EA5E9', fontWeight: '700', fontSize: '12px', width: '#44px', textAlign: 'right', flexShrink: 0 }}>({row.maintRate}%)</span>
                                        <span style={{ width: '25px', textAlign: 'right', flexShrink: 0, marginLeft: '4px' }}>[{row.maintCount}건]</span>
                                        <SearchIcon />
                                    </div>
                                    
                                    <div style={{ color: '#64748B', display: 'flex', alignItems: 'center', width: '165px' }}>
                                        <span style={{ width: '32px', flexShrink: 0 }}>합계:</span>
                                        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: '2px' }}>
                                            <span style={{ color: '#0F172A', fontWeight: '700' }}>{row.totalAmt.toLocaleString()}</span>
                                        </div>
                                        <span style={{ width: '14px', flexShrink: 0, color: '#0F172A', fontWeight: '700' }}>원</span>
                                        <span style={{ color: '#1E3A8A', width: '30px', textAlign: 'right', flexShrink: 0, marginLeft: '1px' }}>[{row.totalCount}건]</span>
                                    </div>
                                </div>
                            </div>

                            <div style={{ width: '100%', height: '32px' }}>
    <ResponsiveContainer width="100%" height="100%">
        <BarChart 
            data={row.chartData} 
            layout="vertical" 
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }} // 매직 넘버 마진 제거
        >
            {/* 1. 배경 그리드를 바 아래에 깔아줌 */}
            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#F1F5F9" />
            
            {/* 2. 축 설정 */}
            <XAxis type="number" domain={[0, 100]} hide />
            <YAxis type="category" dataKey="name" hide />
            
            {/* 3. 데이터 바 (클릭 핸들러 payload 수정 및 커스텀 스타일) */}
            <Bar 
                dataKey="프로젝트율" 
                fill="#1E3A8A" 
                stackId="detail_ratio" 
                maxBarSize={24} 
                style={{ cursor: 'pointer', transition: 'all 0.2s' }} 
                activeBar={{ fill: '#142862', opacity: 0.9 }} 
                onClick={(data) => {
                    // Recharts의 onClick 이벤트 객체에서 원본 데이터(payload) 추출
                    if (data && data.payload) {
                        handleBarClick(data.payload.name, '프로젝트');
                    }
                }} 
            />
            <Bar 
                dataKey="유지보수율" 
                fill="#0EA5E9" 
                stackId="detail_ratio" 
                maxBarSize={24} 
                style={{ cursor: 'pointer', transition: 'all 0.2s' }} 
                activeBar={{ fill: '#0284C7', opacity: 0.9 }} 
                onClick={(data) => {
                    if (data && data.payload) {
                        handleBarClick(data.payload.name, '유지보수');
                    }
                }} 
            />
        </BarChart>
    </ResponsiveContainer>
</div>


                        </div>
                    ))}
                </div>

                <div style={{ width: '100%', height: '36px', marginTop: '-30px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={[{}]} layout="vertical" margin={{ top: 0, right: 0, left: -95, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#F1F5F9" />
                            <XAxis type="number" domain={[0, 100]} tickFormatter={formatXAxis} tick={{ fontSize: 11, fill: '#64748B', fontWeight: '600', dy: 8 }} tickLine={false} axisLine={{ stroke: '#E2E8F0' }} />
                            <YAxis type="category" hide />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

            </div>
        </div>
    );
};

export default SalesDetailBarChart;
